import {
  Building2,
  TrendingUp,
  Scale,
  Wallet,
  Users,
  Briefcase,
  AlertTriangle,
  Clock,
  GitBranch,
  MapPin,
  PieChart,
  BarChart3,
  LineChart,
  Gauge,
  Activity,
  Shield,
  Droplets,
  Gift,
  FileBarChart,
} from 'lucide-react'
import { UsecaseTablesMap } from 'poc-ai-biz-irdb_domain-model'
import { assertNever } from '../../../../_shared/lib'

type UsecaseTableAppearanceConfiguration = {
  displayName: string
  description: string
  icon: React.ReactNode
}

export type UsecaseTableMapKeys = keyof UsecaseTablesMap

export const getUsecaseTableAppearanceConfiguration = (tableName: UsecaseTableMapKeys): UsecaseTableAppearanceConfiguration => {
  switch (tableName) {
    case 'usecaseTableCompanyOverview':
      return {
        displayName: '企業概要',
        description: '企業の基本情報',
        icon: <Building2 className="h-4 w-4" />,
      }
    case 'usecaseTablePlHighlight':
      return {
        displayName: '損益計算書ハイライト',
        description: '損益計算書の主要項目',
        icon: <TrendingUp className="h-4 w-4" />,
      }
    case 'usecaseTableBsHighlight':
      return {
        displayName: '貸借対照表ハイライト',
        description: '貸借対照表の主要項目',
        icon: <Scale className="h-4 w-4" />,
      }
    case 'usecaseTableCfHighlight':
      return {
        displayName: 'キャッシュフロー計算書ハイライト',
        description: 'キャッシュフロー計算書の主要項目',
        icon: <Wallet className="h-4 w-4" />,
      }
    case 'usecaseTableFundamentalsBasic':
      return {
        displayName: 'ファンダメンタルズ_基本',
        description: 'ファンダメンタルズの基本指標',
        icon: <BarChart3 className="h-4 w-4" />,
      }
    case 'usecaseTableFundamentalsGrowth':
      return {
        displayName: 'ファンダメンタルズ_成長性',
        description: '企業の成長性指標',
        icon: <LineChart className="h-4 w-4" />,
      }
    case 'usecaseTableFundamentalsProfitability':
      return {
        displayName: 'ファンダメンタルズ_収益性',
        description: '収益性に関する指標',
        icon: <Gauge className="h-4 w-4" />,
      }
    case 'usecaseTableFundamentalsProductivity':
      return {
        displayName: 'ファンダメンタルズ_生産性',
        description: '生産性に関する指標',
        icon: <Activity className="h-4 w-4" />,
      }
    case 'usecaseTableFundamentalsEfficiency':
      return {
        displayName: 'ファンダメンタルズ_効率性',
        description: '効率性に関する指標',
        icon: <TrendingUp className="h-4 w-4" />,
      }
    case 'usecaseTableFundamentalsSafetyLeverage':
      return {
        displayName: 'ファンダメンタルズ_安全性・レバレッジ',
        description: '安全性とレバレッジに関する指標',
        icon: <Shield className="h-4 w-4" />,
      }
    case 'usecaseTableFundamentalsLiquidity':
      return {
        displayName: 'ファンダメンタルズ_流動性',
        description: '流動性に関する指標',
        icon: <Droplets className="h-4 w-4" />,
      }
    case 'usecaseTableFundamentalsShareholderReturn':
      return {
        displayName: 'ファンダメンタルズ_株主還元',
        description: '株主還元に関する指標',
        icon: <Gift className="h-4 w-4" />,
      }
    case 'usecaseTableExecutiveOverview':
      return {
        displayName: '役員概要',
        description: '役員に関する概要情報',
        icon: <Users className="h-4 w-4" />,
      }
    case 'usecaseTableExecutives':
      return {
        displayName: '役員一覧',
        description: '役員の詳細情報',
        icon: <Users className="h-4 w-4" />,
      }
    case 'usecaseTableExecutiveCompensation':
      return {
        displayName: '役員報酬',
        description: '役員の報酬情報',
        icon: <Wallet className="h-4 w-4" />,
      }
    case 'usecaseTableBusinessDescription':
      return {
        displayName: '事業内容',
        description: '企業の事業内容',
        icon: <Briefcase className="h-4 w-4" />,
      }
    case 'usecaseTableBusinessRisks':
      return {
        displayName: '事業リスク',
        description: '事業に関するリスク情報',
        icon: <AlertTriangle className="h-4 w-4" />,
      }
    case 'usecaseTableHistory':
      return {
        displayName: '沿革',
        description: '企業の沿革情報',
        icon: <Clock className="h-4 w-4" />,
      }
    case 'usecaseTableMajorSubsidiaries':
      return {
        displayName: '主要子会社',
        description: '主要な子会社情報',
        icon: <GitBranch className="h-4 w-4" />,
      }
    case 'usecaseTableOffices':
      return {
        displayName: '事業所',
        description: '事業所の情報',
        icon: <MapPin className="h-4 w-4" />,
      }
    case 'usecaseTableMajorShareholders':
      return {
        displayName: '大株主',
        description: '大株主の情報',
        icon: <PieChart className="h-4 w-4" />,
      }
    case 'usecaseTableKeyManagementIndicatorsConsolidated':
      return {
        displayName: '主要な経営指標等の推移(連結)',
        description: '連結ベースの主要な経営指標',
        icon: <FileBarChart className="h-4 w-4" />,
      }
    case 'usecaseTableKeyManagementIndicatorsNonConsolidated':
      return {
        displayName: '主要な経営指標等の推移(非連結)',
        description: '非連結ベースの主要な経営指標',
        icon: <FileBarChart className="h-4 w-4" />,
      }
    case 'usecaseTablePlFull':
      return {
        displayName: '損益計算書(詳細)',
        description: '損益計算書の詳細情報',
        icon: <TrendingUp className="h-4 w-4" />,
      }
    case 'usecaseTableBsFull':
      return {
        displayName: '貸借対照表(詳細)',
        description: '貸借対照表の詳細情報',
        icon: <Scale className="h-4 w-4" />,
      }
    case 'usecaseTableCfFull':
      return {
        displayName: 'キャッシュフロー計算書(詳細)',
        description: 'キャッシュフロー計算書の詳細情報',
        icon: <Wallet className="h-4 w-4" />,
      }
    default:
      assertNever(tableName)
      throw new Error(`Unknown table name for usecase table appearance configuration: ${tableName}`)
  }
}
